import test from '.RegExp.prototype.test';

import * as options from './options';
import * as TOKEN from './TOKEN';
import Layer, { protect } from './Layer';
import Properties from './Properties';

const notFromOrTo = /*#__PURE__*/test.bind(/^(?!from$|to$)/i);

export default class QualifiedRule extends Layer         {
	
	get [Symbol.toStringTag] () { return 'QualifiedRule'; }
	
	         block = new Properties(this);
	        _empty = true;
	
	constructor () { return super()                   ; }
	
	[TOKEN.consume] (                   ) {
		switch ( TOKEN.type ) {
			case TOKEN.whitespace:
				return this;
			case TOKEN.ident:
				if ( notFromOrTo(TOKEN.literal) ) { break; }
			case TOKEN.percentage:// not style rule
				if ( !this._empty ) { break; }
				this._empty = false;
				this.newItem = TOKEN.literal;
				return this;
			case ',':
				if ( this._empty ) { break; }
				this._empty = true;
				return this;
			case '{':
				if ( this._empty ) { break; }
				return this.block;
			case TOKEN.comment:
				return this;
		}
		return null;
	}
	
	[Symbol.toPrimitive] (                   ) {
		return this.block.length ? `${this.join(',')}{${( '' + this.block ).slice(0, -1)}}` : '';
	}
	
	* [Symbol.iterator] (                   )                                {
		const { block } = this;
		const { length } = block;
		if ( length ) {
			let index = 0;
			if ( options.newlineProperty ) {
				yield `${this.join(', ')} {`;
				while ( index!==length ) {
					for ( const line of block[index++] ) {
						yield options.indent + line;
					}
				}
				yield `}`;
			}
			else {
				let cssText = ' ';
				while ( index!==length ) {
					for ( const line of block[index++]  ) {
						cssText += line + ' ';
					}
				}
				yield `${this.join(', ')} {${cssText}}`;
			}
		}
	}
	
	                                      
	
	static default = protect(this);
	
};

                                              